import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {DetailsPageWrapper} from '@/components/ui/details-atoms/DetailsAtoms'
import {AlertCircleIcon, AlertTriangleIcon} from '@/components/ui/icon/Icon'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {usePermissions} from '@/features/auth/store/store'
import {useGetProject} from '@/features/projects/queries/useGetProject'
import {ProjectDetailsUrlParams} from '@/features/projects/types'
import {useURLParsedParams} from '@/hooks/useURLParsedParams'
import {useTranslation} from '@/translations/i18n'
import {raise} from '@/utilities/helpers'
import {AxiosError} from 'axios'
import {Outlet} from 'react-router-dom'

export const ProjectDetailsRoute = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const urlParams = useURLParsedParams(ProjectDetailsUrlParams)
    const projectId = urlParams.success ? urlParams.data.id : raise('urlParams id is nullish')
    const projectQuery = useGetProject({urlParams: {projectId}, params: {responseType: 'extended'}})

    if (projectQuery.isPending) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <Spinner size={32} style={{placeSelf: 'center'}} />
            </DetailsPageWrapper>
        )
    }

    if (
        !urlParams.success ||
        (projectQuery.error instanceof AxiosError && projectQuery.error.response?.status === 404)
    ) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:invalid_link')} />
            </DetailsPageWrapper>
        )
    }

    if (projectQuery.error) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:default')} />
            </DetailsPageWrapper>
        )
    }
    const isEditable =
        permissions?.projects.write &&
        (projectQuery.data?.status === 'opening' || projectQuery.data.progressStatus === 'incomplete')

    return urlParams.success ? (
        <Outlet context={{project: projectQuery.data, isEditable}} />
    ) : (
        <ErrorBox title={t('errors:invalid_link')} icon={<AlertTriangleIcon />} />
    )
}
